import type { ServicesSectionContent } from "@site-factory/config";
import { SectionTitle, SectionSubtitle } from "../typography/Typography";
import { SectionShell } from "../components/SectionShell";

export interface TimelineSectionProps extends ServicesSectionContent {
  className?: string;
}

/**
 * Timeline/steps layout.
 * Reuses ServicesSectionContent shape: services[] -> steps.
 */
export function TimelineSection({
  title,
  subtitle,
  services: steps,
  className,
}: TimelineSectionProps) {
  return (
    <SectionShell className={className} backgroundClassName="bg-surface-alt">
      {(title || subtitle) && (
        <div className="text-center mb-12">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle className="mt-2">{subtitle}</SectionSubtitle>}
        </div>
      )}

      <div
        className="space-y-8 relative md:before:left-[30px]"
        style={{
          position: "relative",
        }}
      >
        <div
          aria-hidden
          className="pointer-events-none absolute left-[14px] md:left-[30px] top-0 bottom-0 w-px bg-[var(--color-secondary,#94a3b8)] opacity-40"
        />
        {steps.map((step, index) => (
          <div key={index} className="relative pl-10 md:pl-16">
            <div className="absolute left-0 top-1.5 w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center text-sm font-semibold">
              {index + 1}
            </div>
            <div className="bg-[var(--color-surface,#fff)] text-[var(--color-text,#0f172a)] border border-white/10 rounded-[14px] shadow-sm p-4 md:p-6">
              <div className="flex items-center gap-3 mb-2">
                {step.icon && (
                  <span className="text-xl text-primary">{step.icon}</span>
                )}
                <h3 className="text-lg font-semibold">{step.name}</h3>
              </div>
              <p
                className="text-sm"
                style={{ color: "var(--color-text, #0f172a)", opacity: 0.82 }}
              >
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}
